var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconHealthcare48Filled = function SvgIconHealthcare48Filled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.27 17.22c-1.05-3.39-3.97-5.91-7.42-6.43-2.91-.44-5.8.51-7.85 2.49a9.33 9.33 0 0 0-7.85-2.49c-3.45.52-6.36 3.05-7.42 6.43-1.06 3.41-.14 6.74 2.66 9.64.64.66 3.54 3.57 8.86 8.91 1 1 2.33 1.55 3.75 1.55s2.75-.55 3.75-1.55c3.59-3.6 8.05-8.07 8.86-8.91 2.8-2.9 3.72-6.23 2.66-9.64ZM18.5 25.8v-3.6h3.7v-3.7h3.6v3.7h3.7v3.6h-3.7v3.7h-3.6v-3.7h-3.7Z",
    fill: "current"
  })));
};
export default SvgIconHealthcare48Filled;